"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCurrentRemark = exports.clear = exports.updateRemarkInfoValidation = exports.updateRemarkFailed = exports.updateRemarkSuccess = exports.updateRemarkRequest = exports.fetchRemarkFailed = exports.fetchRemarkSuccess = exports.fetchRemarkRequest = exports.createRemarkFailed = exports.createRemarkSuccess = exports.createRemarkRequest = exports.fetchAllFailed = exports.fetchAllSuccess = exports.fetchAllRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.ConfirmationImagesFolderListActions = exports.ImagesFolderListActions = void 0;
const ActionTypes = require("../../actionTypes/trmvrmeterentries/remark");
const _FolderListActions = require("../../modules/files/list/actions");
exports.ImagesFolderListActions = _FolderListActions.default('remark-images');
exports.ConfirmationImagesFolderListActions = _FolderListActions.default('remark-confirmation-images');
function fetchRequest(meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        meterUuid,
        entryUuid
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload, meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload,
        meterUuid,
        entryUuid
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload, meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload,
        meterUuid,
        entryUuid
    };
}
exports.fetchFailed = fetchFailed;
function fetchAllRequest(meterUuid) {
    return {
        type: ActionTypes.FETCH_ALL_REQUEST,
        meterUuid
    };
}
exports.fetchAllRequest = fetchAllRequest;
function fetchAllSuccess(payload, meterUuid) {
    return {
        type: ActionTypes.FETCH_ALL_SUCCESS,
        payload,
        meterUuid
    };
}
exports.fetchAllSuccess = fetchAllSuccess;
function fetchAllFailed(payload, meterUuid) {
    return {
        type: ActionTypes.FETCH_ALL_FAILED,
        payload,
        meterUuid
    };
}
exports.fetchAllFailed = fetchAllFailed;
const createRemarkRequest = (payload) => ({
    type: ActionTypes.CREATE_REMARK_REQUEST,
    payload
});
exports.createRemarkRequest = createRemarkRequest;
const createRemarkSuccess = (payload) => {
    return {
        type: ActionTypes.CREATE_REMARK_SUCCESS,
        payload
    };
};
exports.createRemarkSuccess = createRemarkSuccess;
const createRemarkFailed = (payload) => {
    return {
        type: ActionTypes.CREATE_REMARK_FAILED,
        payload
    };
};
exports.createRemarkFailed = createRemarkFailed;
function fetchRemarkRequest(remarkUuid, meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_REMARK_REQUEST,
        remarkUuid,
        meterUuid,
        entryUuid
    };
}
exports.fetchRemarkRequest = fetchRemarkRequest;
function fetchRemarkSuccess(remark, meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_REMARK_SUCCESS,
        remark,
        meterUuid,
        entryUuid
    };
}
exports.fetchRemarkSuccess = fetchRemarkSuccess;
function fetchRemarkFailed(payload, remarkUuid, meterUuid, entryUuid) {
    return {
        type: ActionTypes.FETCH_REMARK_FAILED,
        payload,
        meterUuid,
        entryUuid
    };
}
exports.fetchRemarkFailed = fetchRemarkFailed;
function updateRemarkRequest(payload) {
    return {
        type: ActionTypes.UPDATE_REMARK_REQUEST,
        payload
    };
}
exports.updateRemarkRequest = updateRemarkRequest;
function updateRemarkSuccess(remark, remarkUuid, meterUuid, entryUuid) {
    return {
        type: ActionTypes.UPDATE_REMARK_SUCCESS,
        remark,
        remarkUuid,
        meterUuid,
        entryUuid
    };
}
exports.updateRemarkSuccess = updateRemarkSuccess;
function updateRemarkFailed(payload, remarkUuid, meterUuid, entryUuid) {
    return {
        type: ActionTypes.UPDATE_REMARK_FAILED,
        payload,
        meterUuid,
        entryUuid
    };
}
exports.updateRemarkFailed = updateRemarkFailed;
function updateRemarkInfoValidation(payload) {
    return {
        type: ActionTypes.UPDATE_REMARK_INFO_VALIDATION,
        payload
    };
}
exports.updateRemarkInfoValidation = updateRemarkInfoValidation;
const clear = () => {
    return {
        type: ActionTypes.CLEAR
    };
};
exports.clear = clear;
const clearCurrentRemark = () => {
    return {
        type: ActionTypes.CLEAR_CURRENT_REMARK
    };
};
exports.clearCurrentRemark = clearCurrentRemark;
//# sourceMappingURL=remark.js.map